import { IRootState } from '../../../app/store';

export const selectUserFavoriteContentAsyncStatus = (state: IRootState) =>
    state.userFavoriteContent.asyncStatus;
export const selectfavoriteSkillList = (state: IRootState) =>
    state.userFavoriteContent.favoriteSkillList;
export const selectfavoritePatientEducationList = (state: IRootState) =>
    state.userFavoriteContent.favoritePatientEducationList;
export const selectSkillListCount = (state: IRootState) =>
    state.userFavoriteContent.skillListCount;
export const selectPatientEducationListCount = (state: IRootState) =>
    state.userFavoriteContent.patientEducationListCount;
export const selectUserFavoriteContentStatusCode = (state: IRootState) =>
    state.userFavoriteContent.statusCode;
export const selectFavoriteSkillDeleteStatus = (state: IRootState) =>
    state.userFavoriteContent.deleteAsyncStatus;
